const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
const countryCodes = new Map<string, string>();
for (let a = 65; a <= 90; a++) {
  for (let b = 65; b <= 90; b++) {
    const code = String.fromCharCode(a, b);
    const name = regionNames.of(code);
    if (name && name !== code) countryCodes.set(name.toLowerCase(), code);
  }
}
export function countryLabel(country: string): string {
  const code =
    countryCodes.get(country.toLowerCase()) ??
    (/^[A-Z]{2}$/.test(country) ? country : null);
  if (!code) return country;
  const flag = [...code]
    .map((c) => String.fromCodePoint(c.charCodeAt(0) + 127397))
    .join('');
  return `${flag} ${country}`;
}
